export default [
    {
        path: '',
        redirect: {name: 'SelectProject'}
    },
    {
        path: 'selectProject',
        name: 'SelectProject',
        alias: 'recommend',
        component: r => require.ensure([], () => r(require('@/examination/thirdRound/selectProject')))
        // children: [
        //     {
        //         path: 'totalState/:classId?',
        //         name: 'totalState',
        //         component: r => require.ensure([], () => r(require('@/examination/thirdRound/details/totalState')), 'detail'),
        //         meta: {
        //             title: ''
        //         }
        //     },
        //     {
        //         path: 'classSituation/:classId?',
        //         name: 'classSituation',
        //         component: r => require.ensure([], () => r(require('@/examination/thirdRound/details/classSituation')), 'detail'),
        //         meta: {
        //             title: ''
        //         }
        //     }
        // ]
    },
    // {
    //     path: 'finalPapers',
    //     name: 'FinalPapers',
    //     component: r => require.ensure([], () => r(require('@/examination/thirdRound/finalPapers')))
    // },
    {
        path: 'paperDetail',
        name: 'PaperDetail',
        component: r => require.ensure([], () => r(require('@/examination/thirdRound/paperDetail')))
    }
    // {
    //     path: 'moreInfo',
    //     name: 'moreInfo',
    //     component: r => require.ensure([], () => r(require('@/views/details/moreInfo')), 'detail'),
    //     meta: {
    //         title: ''
    //     }
    // }
]




// WEBPACK FOOTER //
// ./src/router/thirdRound.js